/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const split = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.133 9.867 15 11.733m0 0L13.133 13.6M15 11.733l-3.267.002C9.4 11.735 7.533 8 7.533 8m5.6-5.601L15 4.267m0 0-1.867 1.866M15 4.267h-3.267c-2.333 0-4.2 3.734-4.2 3.734m0 0L1 8"
    />
  </svg>
)
export default split
